function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// eslint-disable-next-line no-undef
import version from './version';
/**
 * @typedef { import ('./player').default } Player
 */

var ERROR_TYPE_MAP = {
  1: 'network',
  2: 'network',
  3: 'decoder',
  4: 'format'
};
var ErrorTypes = {
  network: {
    code: 1
  },
  mse: {
    code: 2
  },
  parse: {
    code: 3
  },
  format: {
    code: 4
  },
  decoder: {
    code: 5
  },
  runtime: {
    code: 6
  },
  timeout: {
    code: 7
  },
  other: {
    code: 8
  }
};
/**
 * @typedef { {
 *   playerVersion: string,
 *   domain: string,
 *   currentTime: number,
 *   duration: number,
 *   ended: boolean,
 *   readyState: number,
 *   networkState: number,
 *   src: any,
 *   errorType: string,
 *   errorCode: number,
 *   message: string,
 *   mediaError?: {
 *     code: number,
 *     message?: string
 *   },
 *   originError?: any,
 *   url?: any,
 *   [propName: string]: any
 * } } IError
 */

/**
 * @type { IError }
 */

var Errors =
/**
 *
 * @param { Player } player
 * @param { {
 * errorType: string,
 * errorCode: number,
 * errorMessage: string,
 * originError: any,
 * ext: { [propName: string]: any; }
 * } } errorInfo
 * @returns
 */
function Errors(player) {
  var errorInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    errorType: '',
    errorCode: 0,
    errorMessage: '',
    originError: '',
    ext: {},
    mediaError: null
  };

  _classCallCheck(this, Errors);

  var ERROR_TYPES = player && player.i18n ? player.i18n.ERROR_TYPES : null;

  if (player.video) {
    var mediaError = errorInfo.mediaError ? errorInfo.mediaError : player.video.error || {};
    var duration = player.duration,
        currentTime = player.currentTime,
        ended = player.ended,
        src = player.src,
        currentSrc = player.currentSrc;
    var _player$video = player.video,
        readyState = _player$video.readyState,
        networkState = _player$video.networkState;
    var r = {
      playerVersion: version,
      domain: document.domain,
      currentTime: currentTime,
      duration: duration,
      ended: ended,
      readyState: readyState,
      networkState: networkState,
      src: src || currentSrc,
      errorType: errorInfo.errorType,
      errorCode: errorInfo.errorCode || mediaError.code,
      message: errorInfo.errorMessage || mediaError.message,
      mediaError: mediaError,
      originError: errorInfo.originError ? errorInfo.originError.stack : ''
    };
    errorInfo.ext && Object.keys(errorInfo.ext).map(function (key) {
      r[key] = errorInfo.ext[key];
    });
    return r;
  } else {
    if (arguments.length > 1) {
      var _r = {
        playerVersion: version,
        domain: document.domain
      };
      var arr = ['errorType', 'currentTime', 'duration', 'networkState', 'readyState', 'src', 'currentSrc', 'ended', 'errd', 'errorCode', 'mediaError'];

      for (var i = 0; i < arguments.length; i++) {
        _r[arr[i]] = arguments[i];
      }

      _r.ex = ERROR_TYPES ? (ERROR_TYPES[arguments[0]] || {}).msg : ''; // 补充信息

      return _r; // r.playerVersion = version // 播放器版本
      // r.errorType = arguments[0]
      // r.domain = document.domain // domain
      // r.duration = duration // 视频时长
      // r.currentTime = currentTime
      // r.networkState = networkState
      // r.readyState = readyState
      // r.currentSrc = currentSrc
      // r.src = src
      // r.ended = ended
      // r.errd = errd // 错误详情
      // r.ex = (ErrorTypes[type] || {}).msg // 补充信息
      // r.errorCode = errorCode
      // r.mediaError = mediaError
    }
  }
};

export { Errors as default, ErrorTypes, ERROR_TYPE_MAP };